//
// URL Query to Cookie
// --------------------------------------------------
// Fetches desired queries from url and stores in cookies if they exist on page load
// Cookies are then referenced in /forms.js to set form values

window.addEventListener('load', event => {
    const urlQueryParameters = getQueryParameters();
    setQueryParamsAsCookies(urlQueryParameters);
});

// Gets url from search bar and splits any query parameters found into a name / value
function getQueryParameters() {
    let searchParams = new URLSearchParams(window.location.search);

    return [...searchParams.keys()].filter((key,index,arr) => arr.indexOf(key) === index).reduce((acc,key) => {
        acc[key]=searchParams.getAll(key);
        return acc;
    }, {});
}

// Gets passed urlQueryParameters that has been defined by getQueryParameters()
// Sets desired query parameters as cookies for access via freeform, etc.
function setQueryParamsAsCookies(urlQueryParameters) {
    const utmQueries = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

    // Loops through utmQueries and sets cookies if the query is found in urlQueryParameters
    // Cookie name = utmQuery
    // Cookie value = value in urlQueryParameters that has a name matching utmQuery
    for (let utmQuery of utmQueries) {
        if (utmQuery in urlQueryParameters) {
            Cookies.set(utmQuery, urlQueryParameters[utmQuery][0], { expires: 7 });
        }
    }

    // Sets gclid (google advertisement ref) as a cookie for freeform reference
    if ('gclid' in urlQueryParameters) {
        Cookies.set('ff_gclid', urlQueryParameters['gclid'][0], { expires: 1 });
    }
}